<template>
    <div class="honor-page">
        <!-- 背景图 -->
        <div class="honor-page-bg" :class="{
            'honor-page-medalBg': currentChoose == 'medal'
        }"></div>
        <!-- top -->
        <div class="top" :style="{paddingTop: 10 + statusBarHeight + 'px'}">
            <div
                class="top-back"
            >
                <Back 
                    :clickHandle="handleClosePage"
                    :innerText="localesPackage?.['badgewall_back']?.[localesEnv]"
                />
            </div>
            <div class="top-right" v-show="currentChoose == 'static'">
                <div class="top-right-iconView" @click="toSharePage">
                    <img
                        class="top-right-iconView-bg"
                        :src="require('@/assets/images/YuliApp/badgeWall/top_right_tag_bg.png')"
                    />
                    <img class="top-right-iconView-icon-share" 
                         :src="require('@/assets/images/YuliApp/badgeWall/icon_share.png')">
                    <span>{{ localesPackage?.['badgewall_share']?.[localesEnv] }}</span>
                </div>
            </div>
        </div>
        <!-- 额外页面导入 -->
        <Statistics v-show="currentChoose == 'static'" 
                    @handle="msgHandle" 
                    :RadarData="useRadarData" 
                    :medalData="medalTotalData">
        </Statistics>
        <Medal v-show="currentChoose == 'medal'" 
                @handle="msgHandle" 
                :newBadgeFlag="newBadgeFlag"
                :DataBase="DataBase">
        </Medal>
        <Ranking v-if="rankingPageVisiable" @handle="msgHandle" :rankData="rankingDataMap"></Ranking>
        <medal-detail-page v-if="medalDetailVisiable" 
                            :medalItem="currentMedal" 
                            @handle="msgHandle" 
                            :newBadgeFlag="newBadgeFlag"
                            :medalData="medalTotalData">
        </medal-detail-page>
        <!-- footer -->
        <div class="footer">
            <div class="switch-item" @click="changeChoose('static')">
                <img v-if="currentChoose == 'static'" :src="require('@/assets/images/YuliApp/badgeWall/honerPage/statistics_active.png')">
                <img v-else :src="require('@/assets/images/YuliApp/badgeWall/honerPage/statistics_normal.png')">
                <div class="switch-item-content" :class="{'switch-item-contentActive': currentChoose == 'static'}">
                    <img :src="require(
                        currentChoose == 'static' 
                        ? '@/assets/images/YuliApp/badgeWall/honerPage/icon_statistics.svg' 
                        : '@/assets/images/YuliApp/badgeWall/honerPage/icon_statistics_normal.svg'
                    )">
                    <span>{{ localesPackage?.['badgewall_statistics']?.[localesEnv] }}</span>
                </div>
            </div>
            <div class="switch-item" @click="changeChoose('medal')">
                <img v-if="currentChoose == 'medal'" :src="require('@/assets/images/YuliApp/badgeWall/honerPage/medel_active.png')">
                <img v-else :src="require('@/assets/images/YuliApp/badgeWall/honerPage/medel_normal.png')">
                <div class="switch-item-content" :class="{'switch-item-contentActive': currentChoose == 'medal'}">
                    <img :src="require(
                        currentChoose == 'medal' 
                        ? '@/assets/images/YuliApp/badgeWall/honerPage/icon_medal.svg'
                        : '@/assets/images/YuliApp/badgeWall/honerPage/icon_medal_normal.svg'
                    )">
                    <span>{{ localesPackage?.['badgewall_medal']?.[localesEnv] }}</span>
                </div>
                <!-- 红点 -->
                <div class="switch-item-redPoint" v-show="newBadgeFlag"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { onBeforeMount, getCurrentInstance, ref, computed, nextTick } from "vue";
import _ from "lodash";
import { mapState } from "vuex";
import appBridging from "@/utils/appBridging.js";
import { px2rem } from "@//utils/utils.js";
import Medal from './components/Medal';
import Statistics from './components/Statistics';
import Back from "@/components/universal/Back";
import Ranking from "./components/Ranking.vue";
import MedalDetailPage from "./components/MedalDetailPage.vue";
import { getBadgeRanking } from "@/api/badgeWall.js";
import { TOAST_TYPE } from "@/components/Toast/index.vue";

export default {
    components: {
        Medal,
        Statistics,
        Ranking,
        MedalDetailPage,
        Back
    },
    props: {
        cur_kep: {
            type: Number,
            default: 0,
        },
        DataBase: {
            type: Object,
            default: () => {
                return null
            }
        },
        RadarData: {
            type: Object,
            default: () => {
                return null
            }
        },
        appUserInfo: {
            type: Object,
            default: () => {
                return null
            }
        },
        newBadgeFlag: {
            default: false
        }
    },
    computed: {
        ...mapState({
            init: (state) => state.global.init,
            statusBarHeight: (state) => state.global.statusBarHeight,
            languageEnv: (state) => state.global.languageEnv,
            languagePackage: (state) => state.global.languagePackage,
        }),
    },
    watch: {
        languageEnv: {
            async handler(value) {
                if(value){
                this.localesEnv = value;
                }
            },
            immediate: true,
            deep: true,
        },
        languagePackage: {
            async handler(value) {
                if(value){
                this.localesPackage = value;
                }
            },
            immediate: true,
            deep: true,
        },
        RadarData: {
            async handler(value) {
                if(value){
                    this.useRadarData = value;
                    this.checkCompleteState(value);
                }
            },
            immediate: true,
            deep: true,
        }
    },
    setup(props, { emit }) {
        const { proxy } = getCurrentInstance();
        /**语言包 - ref */
        const localesPackage = ref({});
        /**语言环境 - ref */
        const localesEnv = ref('en');
        const currentChoose = ref('static');
        const rankingPageVisiable = ref(false);
        const medalDetailVisiable = ref(false);
        const medalTotalData = ref({});
        const currentMedal = ref(null);
        const useRadarData = ref([
            {
                name: 'YULI’s growth',
                max: 10000,
                value: 7500,
            },
            {
                name: 'Chip\nenhancement',
                max: 10000,
                value: 7500,
            },
            {
                name: 'Material\nsynthesis',
                max: 10000,
                value: 7500,
            },
            {
                name: 'COA',
                max: 10000,
                value: 7500,
            },
            {
                name: 'Purification\nof Terra',
                max: 10000,
                value: 7500,
            },
            {
                name: 'Guide’s\ndevelopment',
                max: 10000,
                value: 7500,
            },
        ]);
        const rankingDataMap = ref(null);
        const appUserAddress = ref(null);

        const changeChoose = (value) => {
            currentChoose.value = value;
        }

        onBeforeMount(()=>{
            appBridging.getStatusBarHeight();
            getRankingRequestHandle();
        })

        /**获取排行榜数据 */
        const getRankingRequestHandle = async () => {
            proxy.$loading.show(); // 显示loading
            const RANK_KEY = 'ranking_data_group';
            const userAddress = props.DataBase?.address || '';
            const rankingData = sessionStorage.getItem(RANK_KEY);
            let pointRankRes = [];
            let medalRankRes = [];
            const userRankingData = {};
            let useTotalPeopleLocal = 0;
            if(rankingData){
                const res = JSON.parse(rankingData);
                const { point, medal, peopleTotal, userRankingData: userRankingDataLocal } = res;
                userRankingData.pointRank = userRankingDataLocal?.pointRank || null;
                userRankingData.medalRank = userRankingDataLocal?.medalRank || null;
                pointRankRes = point;
                medalRankRes = medal;
                useTotalPeopleLocal = peopleTotal;
            }else{
                try {
                    const res = await getBadgeRanking('');
                    // 获取最后一位信息，其username字段代表总人数
                    const configData = res.data[res.data.length-1];
                    const pointTempGroup = [];
                    res.data.pop();
                    const useRes = res.data;
                    pointRankRes = useRes
                    ?.sort((pre,next) => next.arg - pre.arg)
                    ?.map((item, index) => {
                        const endRes = {
                            ...item,
                            realRanking: index+1
                        }
                        if(index !== 0){
                            // 排除第一个
                            const lastItem = pointTempGroup?.[index - 1]; //获得上一个元素
                            if(lastItem && lastItem?.arg === item.arg ){
                                endRes.ranking = lastItem.ranking;
                            }else {
                                endRes.ranking = index+1;
                            }
                        }else endRes.ranking = index+1;
                        pointTempGroup.push(endRes);
                        return endRes;
                    }) || [];
                    userRankingData.pointRank = {ranking: configData?.arg} || null;
                    // 总人数赋值
                    useTotalPeopleLocal = configData.username;
                    const res2 = await getBadgeRanking('medal');
                    const configData2 = res2.data[res2.data.length-1];
                    const medalTempGroup = [];
                    res2.data.pop();
                    const useRes2 = res2.data;
                    medalRankRes = useRes2
                    ?.sort((pre,next) => next.arg - pre.arg)
                    ?.map((item, index) => {
                        const endRes = {
                            ...item,
                            realRanking: index+1
                        }
                        if(index !== 0){
                            // 排除第一个
                            const lastItem = medalTempGroup?.[index - 1]; //获得上一个元素
                            if(lastItem && lastItem?.arg === item.arg ){
                                endRes.ranking = lastItem.ranking;
                            }else {
                                endRes.ranking = index+1;
                            }
                        }else endRes.ranking = index+1;
                        medalTempGroup.push(endRes);
                        return endRes;
                    }) || [];
                    userRankingData.medalRank = {ranking: configData2?.arg} || null;
                    sessionStorage.setItem(RANK_KEY, JSON.stringify({
                        point: pointRankRes,
                        medal: medalRankRes,
                        peopleTotal: configData.username,
                        userRankingData
                    }));
                } catch (error) {
                    proxy.$toast.show({
                        msg: `${localesPackage.value?.['katharsis_toast_msg1']?.[localesEnv.value]}.`,
                        type: TOAST_TYPE.ERROR,
                    });
                    console.log(error);
                }
            }
            rankingDataMap.value = {
                point: pointRankRes,
                medal: medalRankRes,
                userAddress,
                useTotalPeople: useTotalPeopleLocal,
                appUserInfo: props.appUserInfo || {},
                userRankingData,
            }
            medalTotalData.value = {
                ...medalTotalData.value,
                userRankingData,
                useTotalPeople: useTotalPeopleLocal
            }
            proxy.$loading.hide();
        } 

        const handleClosePage = () => {
            emit('handle', false);
        }

        const toSharePage = () => {
            emit('handle', 'share', {
                RadarData: useRadarData.value,
                medalTotalData: medalTotalData.value
            });
        }

        const msgHandle = (state, data2) => {
            if(state == 'rank-open'){
                rankingPageVisiable.value = true;
                return;
            }
            if(state == 'rank-close'){
                rankingPageVisiable.value = false;
                return;
            }
            if(state == 'medal-detail-open'){
                medalDetailVisiable.value = true;
                currentMedal.value = data2;
                return;
            }
            if(state == 'medal-detail-close'){
                medalDetailVisiable.value = false;
                return;
            }
            if(state == 'badgeShare'){
                emit('handle', 'badgeShare', {
                    currentMedal: currentMedal.value,
                    medalTotalData: medalTotalData.value
                });
                return;
            }
            if(state == 'medal-total-data'){
                medalTotalData.value = {
                    ...medalTotalData.value,
                    ...data2,
                };
                emit('handle', 'medalTotalData', medalTotalData.value);
                return;
            }
            if(state == 'remove-red-point'){
                emit('handle', 'remove-red-point', data2);
                return;
            }
        }

        /**检测用户完成情况 */
        const checkCompleteState = (raderData) => {
            let isDone = false;
            for(let i = 0; i < raderData.length; i++){
                const { max, value } = raderData[i];
                if(value >= max){
                    if(i == (raderData.length - 1)){
                        isDone = true;
                    }
                }else break;
            }
            medalTotalData.value = {
                ...medalTotalData.value,
                isDone
            }
            return isDone;
        }

        return {
            msgHandle,
            handleClosePage,
            checkCompleteState,
            changeChoose,
            toSharePage,
            localesPackage,
            localesEnv,
            currentChoose,
            useRadarData,
            medalTotalData,
            rankingDataMap,
            appUserAddress,
            currentMedal,
            rankingPageVisiable,
            medalDetailVisiable,
        };
    },
};
</script>
  
<style lang="less" scoped>
@topHeight: 60px;
@screenTop: 10px;
.honor-page{
    width: 100vw;
    height: 100vh;
    position: fixed;
    background: linear-gradient(180deg,
        #A89E80 0%,
        #A39988 15%,
        #D0C6B6 50%,
        #B4AA99 82%,
        #AFA494 100%
    );
    z-index: 999;
    top: 0;
    left: 0;
    &-bg{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: -1;
        background: url("~@/assets/images/YuliApp/badgeWall/honerPage/MedelWallBg.png") no-repeat
        top left;
        background-size: 100% 100%;
    }
    &-medalBg{
        background: url("~@/assets/images/YuliApp/badgeWall/honerPage/medal_bg.png") no-repeat
        top left;
        background-size: 100% 100%;
    }
    .top{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 12;
        width: 100%;
        height: @topHeight;
        &-back{
            position: absolute;
            width: 64px;
            height: 32px;
            top: 50%;
            left: 0;
            transform: translate(0,-50%);
            img{
                width: 100%;
                height: 100%;
            }
        }
        &-right{
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            &-iconView{
                width: 82px;
                height: 26px;
                position: relative;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                color: #ffffff;
                font-family: "PingFang SC";
                font-size: 12px;
                font-weight: 500;
                &-bg{
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    z-index: -1;
                }
                &-icon-share{
                    width: 24px;
                    height: 24px;
                    margin-right: 2px;
                }
            }
        }
        &-tag{
            position: absolute;
            top: 50%;
            right: 0;
            transform: translate(0,-50%);
            font-size: 16px;
            width: fit-content;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 4px 10px;
            background-color: aquamarine;
            border-radius: 20px 0 0 20px;
        }
    }
    .footer{
        position: fixed;
        bottom: 0;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .switch-item{
            width: 50%;
            height: 55px;
            position: relative;
            img{
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                z-index: -1;
            }
            &-content{
                margin-top: 6.5px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                img{
                    position: unset;
                    width: 28px;
                    height: 28px;
                    // fill: #96979D;
                }
                span{
                    color: #98999a;
                    font-family: "PingFang SC";
                    font-size: 13px;
                    font-weight: 500;
                    line-height: 16px;
                }
            }
            &-contentActive{
                img{
                    // fill: unset;
                }
                span{
                    color: #ffffff;
                }
            }
            &-redPoint{
                position: absolute;
                top: 2px;
                right: 8px;
                width: 16px;
                height: 16px;
                background: url("~@/assets/images/YuliApp/badgeWall/RewardSignal.png") no-repeat
                top left;
                background-size: 100% 100%;
            }
        }
    }
}
</style>
  